function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 100 100",
  overflow: "visible"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#C4D600",
  strokeWidth: "12",
  strokeLinecap: "square",
  d: "M10 10l80 80M90 10L10 90"
}));